/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @version 1.4.0
 * @since 1.0.0
 */
import styled from 'styled-components';

import { globalThemeConstants } from '../../../theme';

/**
 * @description Define max-width to global containers like pages, Header & Footer content
 * These containers should extends this styles
 * Some component like Header, Footer, Table containers are filled all space
 */
const GlobalContainer = styled.div.attrs(({ className = '' }: { className?: string }) => ({
    className: `global-container ${className}`,
}))`
    width: 100%;
    max-width: ${globalThemeConstants.maxSiteWidth};
    min-width: ${globalThemeConstants.minSiteWidth}; // TODO waiting for design for the adaptive view
    margin: 0 auto;
    box-sizing: border-box;
`;

export default GlobalContainer;
